import TreeView from "Components/TreeView/TreeView";
import i18n from "i18next";
import { Area } from "Models/Areas/Area";
import * as React from "react";
import { connect } from "react-redux";
import { Action, Dispatch } from "redux";
import ServiceProvider from "ServiceProvider/ServiceProvider";
import Types from "ServiceProvider/Types";
import { IAreaState } from "Store/Areas/AreaState";
import { IAreaAction } from "Store/Areas/IAreaAction";
import { IApplicationState } from "Store/Store";
import FilterCard from "../../FilterCard/FilterCard";

const mapDispatchToProps = (dispatch: Dispatch) => ({    
    getCompanyAreas: () => {
        const areaAction: IAreaAction = ServiceProvider.get<IAreaAction>(Types.IAreaAction);
        return dispatch(areaAction.getAreasByCompanyId());
    }
});

const mapStateToProps = (state: IApplicationState) => ({
    areaState: state.areaState    
});

interface IProps {
    areaState: IAreaState;
    selectedArea?: Area;
    getCompanyAreas: () => Action;
    onSelectArea: (area?: Area) => void;
}

interface IState {
    areas?: Area[];
    selectedPath: Area[];
}

export class AreaFilterCard extends React.Component<IProps, IState> {
    
    constructor(props: IProps) {
        super(props);

        this.state = {
            selectedPath: props.selectedArea ? AreaFilterCard.createPath(props.selectedArea) : []
        };

        this.props.getCompanyAreas();
        
        this.updatePath = this.updatePath.bind(this);
        this.clear = this.clear.bind(this);
    }

    public static getDerivedStateFromProps(nextProps: IProps, prevState: IState): Partial<IState> {
        const state: Partial<IState> = {};
        const path = prevState.selectedPath;

        if (nextProps.areaState.companyAreas !== prevState.areas) {
            state.areas = nextProps.areaState.companyAreas;
        }
        
        if (path.length && !nextProps.selectedArea) {
            state.selectedPath = [];
        }
        else if(path && nextProps.selectedArea && nextProps.selectedArea !== (path.length ? path[path.length - 1] : undefined)) {
            state.selectedPath = AreaFilterCard.createPath(nextProps.selectedArea);
        }

        return state;
    }

    private static createPath = (area: Area): Area[] => area.parent ? [...AreaFilterCard.createPath(area.parent), area] : [area]; 

    public updatePath(path: Area[]) {
        this.setState({
            selectedPath: path
        });
        this.props.onSelectArea(path.length ? path[path.length - 1] : undefined);
    }

    public clear() {
        this.updatePath([]);
    }

    public equal(area1: Area, area2: Area): boolean {
        return area1 && area2 && area1.id === area2.id;
    }

    public render() {  
        return (
            <FilterCard title={i18n.t("tasks.area.title")} onClear={this.state.selectedPath.length ? this.clear : undefined}>
                <TreeView data={this.state.areas} titleField="name" childrenField="children" updatePath={this.updatePath} selectedPath={this.state.selectedPath} equalityComparer={this.equal} /> 
            </FilterCard>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AreaFilterCard);


// WEBPACK FOOTER //
// ./src/Components/Common/FilterBar/FilterCards/AreaFilterCard/AreaFilterCard.tsx